type PurchaseDisplayLike = {
  id: number;
  public_id?: string | null;
};

export const getPurchaseDisplayId = (purchase: PurchaseDisplayLike): string =>
  purchase.public_id || String(purchase.id);

export const getPurchaseDisplaySortKey = (purchase: PurchaseDisplayLike): string => {
  const displayId = getPurchaseDisplayId(purchase);
  const match = displayId.match(/^(\d+)(?:\.(\d+))?$/);
  if (!match) return displayId;

  const base = match[1].padStart(12, '0');
  const subtaskSeq = (match[2] || '0').padStart(6, '0');
  return `${base}.${subtaskSeq}`;
};

export const resolvePurchaseTechnicalIdFromInput = (
  inputValue: string,
  purchases: PurchaseDisplayLike[]
): number | null => {
  const normalized = inputValue.trim();
  if (!normalized) return null;

  const identifierMatch = normalized.match(/^#?\s*(\d+(?:\.\d+)?)\b/);
  if (!identifierMatch) return null;
  const identifier = identifierMatch[1];

  const byPublicId = purchases.find((purchase) => purchase.public_id === identifier);
  if (byPublicId) return byPublicId.id;

  // Só resolve ID técnico quando ele existe na lista carregada.
  // Evita tratar um ID público (ex.: 10002) como técnico quando a PR ainda
  // não está em `purchases` — nesse caso o backend resolve via purchase_public_id.
  if (/^\d+$/.test(identifier)) {
    const technicalId = Number.parseInt(identifier, 10);
    const byTechnicalId = purchases.find((purchase) => purchase.id === technicalId);
    if (byTechnicalId) return byTechnicalId.id;
  }

  return null;
};
